import styled from "styled-components";

export const MonthYearPickerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  .label {
    font-size: 14px;
    font-weight: 500;
    color: #2b3952;
  }

  .picker-wrapper {
    display: flex;
    align-items: center;
    border: 1px solid #080425;
    border-radius: 4px;
    background: #f4f4ff;
  }

  .custom-select {
    flex: 1;
    position: relative;
    border-radius: 4px;
    overflow: hidden;

    .picker-select {
      height: 36px !important;
      border: none;
      background: transparent;
      margin: 0 8px;
      text-align: center; 
      &:focus {
        outline: none;
      }

      &::before {
        display: none; /* Remove the default bottom border */
      }
    }
  }

  .divider {
    width: 1px;
    height: 24px;
    background: #080425;
    margin: 0 8px;
  }
`;
